import { render, staticRenderFns } from "./BusinessContext.vue?vue&type=template&id=0735a8a3&scoped=true&"
import script from "./BusinessContext.vue?vue&type=script&lang=js&"
export * from "./BusinessContext.vue?vue&type=script&lang=js&"
import style0 from "./BusinessContext.vue?vue&type=style&index=0&id=0735a8a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0735a8a3",
  null
  
)

export default component.exports